<template>
	<!-- 下载弹窗 -->
  <el-dialog
    :visible.sync="dialogVisible"
    width="540px"
    top="30vh"
    @close="handleClose"
    center
    append-to-body>
    <span slot="title"></span>
    <span slot="footer"></span>
    <span>需要注意的是内容是默认不居中的</span>
    
  </el-dialog>
</template>
<script>
export default {
  name: 'DownloadDialog',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleClose() {
      // Dialog关闭时的回调
      this.$emit('close')
    },
  }
}
</script>
<style scoped>
.bottom-banner-section {
  color: #21042e; 
}
.bottom-banner-section-container {
  height: 340px;
  width: 83%;
  border-radius: 30px;
  color: white;
  background-image: url('/static/contact_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
}
.bottom-banner-section .content {
  height: 340px;
  font-size: 36px;
  font-weight: 600;
}
.bottom-banner-section .banner-btn {
  width: 140px;
  height: 50px;
  border-radius: 30px;
  font-size: 14px;
  line-height: 100%;
  color: #fff;
  border: none;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
}
</style>


// WEBPACK FOOTER //
// src/components/DownloadDialog.vue